import React from 'react';
import { X } from 'lucide-react';
interface TreatmentFailureCardProps {
  title: string;
  children: ReactNode;
}
export function TreatmentFailureCard({
  title,
  children
}: TreatmentFailureCardProps) {
  return <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-taupe/20 my-6 relative overflow-hidden" data-id="element-252">
      <div className="absolute top-0 left-0 w-1 h-full bg-[#A36B5D]/60" data-id="element-253"></div>
      <div className="flex items-start gap-4 mb-4" data-id="element-254">
        <div className="flex-shrink-0 mt-1 bg-[#F5EBE6] p-1.5 rounded-full text-[#A36B5D]" data-id="element-255">
          <X size={16} strokeWidth={3} data-id="element-256" />
        </div>
        <h3 className="text-xl font-serif font-medium text-forest m-0 leading-tight" data-id="element-257">
          {title}
        </h3>
      </div>
      <div className="text-ink/80 leading-relaxed pl-11" data-id="element-258">{children}</div>
    </div>;
}